module.exports = __webpack_public_path__ + "img/book-3.2eec4053.png";